// * Import 3rd party
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(
  Button,
  {}
)(({ theme, customProps }) => ({
  textTransform: "none",
  "&.MuiButton-root": { boxShadow: "none !important" },
  color: theme.palette.primary.darkViolet,
}));

export default StyledButton;
